<script setup lang="ts">
import {computed, onMounted, ref} from 'vue'
import {$inj} from '@/common/decorators/depinject.ts'
import {ActiveUserService} from '@/common/services/ActiveUser/ActiveUserService.ts'
import {
  type IInstitution,
  InstitutionListService
} from '@/common/services/InstitutionListService/institutionListService.ts'

const activeUserService = $inj(ActiveUserService)
const institutionListService = $inj(InstitutionListService)
const institutionList = ref<Array<IInstitution>>([])

onMounted(() => {
  activeUserService.getActiveUser().then((response) => {
    institutionListService
      .getAll(response.data.payload.jhid)
      .then((response) => {
        institutionList.value = response.data.institutions
      })
  })
})

const currentInstitution = computed(() =>
  institutionList.value.find(
    (institution) => institution.institutionId === (window.INSTITUTION_ID ?? window.institutionConfig?.id)
  )
)

const backgroundColor = computed(
  () => `#${currentInstitution.value?.institutionId.substr(0, 6)}`
)

const subdomain = computed(() => {
    const { hostname } = new URL(window.location.origin)
    const parts = hostname.split('.')
    return parts.length > 2
      ? parts.slice(0, -2).join('.')
      : ''
})
</script>

<template>
  <span
    v-if="currentInstitution"
    id="institution-label"
    :style="{backgroundColor}">
    {{ currentInstitution?.name }}
  </span>
</template>

<style scoped>
#institution-label {
  padding: 0 var(--jh-space-200);
  border-radius: 5px;
}
</style>
